import { render, staticRenderFns } from "./PlayerControlItem.vue?vue&type=template&id=429a3975&"
import script from "./PlayerControlItem.vue?vue&type=script&lang=js&"
export * from "./PlayerControlItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports